export const version = "providers/5.5.2";
//# sourceMappingURL=_version.js.map